export const COD_TIPO_DOC_RUT: number = 2;
export const COD_TIPO_DOC_CI: number = 3;
export const COD_TIPO_DOC_OTROS: number = 4;
export const COD_TIPO_DOC_DNI: number = 6;
